/* eslint-disable no-useless-concat */
import { ApexOptions } from "apexcharts";

const primary = "var(--theme-default)";
const secondary = "var(--theme-secondary)";

/*=======/Subscripationchart/=======*/

export const SubScripationChart: ApexOptions = {
  series: [
    {
      name: "Desktops",
      data: [30, 50, 50, 50, 25, 25, 25, 2, 2, 2, 25, 25, 25, 62, 62, 62, 35, 35, 35, 66, 66],
    },
  ],
  chart: {
    height: 165,
    type: "area",
    zoom: {
      enabled: false,
    },
    toolbar: {
      show: false,
    },
    dropShadow: {
      enabled: true,
      top: 0,
      left: 0,
      blur: 3,
      opacity: 0.2,
    },
  },
  colors: ["#dd7031"],
  fill: {
    type: "gradient",
    gradient: {
      shade: "light",
      type: "vertical",
      opacityFrom: 0.4,
      opacityTo: 0.1,
      stops: [0, 100],
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: "straight",
    width: 2,
  },
  tooltip: {
    enabled: false,
  },
  grid: {
    yaxis: {
      lines: {
        show: false,
      },
    },
  },
  xaxis: {
    labels: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    show: false,
  },
  markers: {
    discrete: [
      {
        seriesIndex: 0,
        dataPointIndex: 1,
        fillColor: "#fff",
        strokeColor: "#dd7031",
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 0,
        dataPointIndex: 6,
        fillColor: "#fff",
        strokeColor: "#dd7031",
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 0,
        dataPointIndex: 9,
        fillColor: "#fff",
        strokeColor: "#dd7031",
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 0,
        dataPointIndex: 12,
        fillColor: "#fff",
        strokeColor: "#dd7031",
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 0,
        dataPointIndex: 13,
        fillColor: "#fff",
        strokeColor: "#dd7031",
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 0,
        dataPointIndex: 16,
        fillColor: "#fff",
        strokeColor: "#dd7031",
        size: 3,
        shape: "circle",
      },
      {
        seriesIndex: 0,
        dataPointIndex: 19,
        fillColor: "#fff",
        strokeColor: "#dd7031",
        size: 3,
        shape: "circle",
      },
    ],
  },
  responsive: [
    {
      breakpoint: 1362,
      options: {
        series: [
          {
            data: [30, 50, 50, 50, 25, 25, 25, 2, 2, 2, 25, 25, 25, 62, 62, 62],
          },
        ],
        chart: {
          height: 170,
        },
      },
    },
    {
      breakpoint: 1200,
      options: {
        series: [
          {
            data: [30, 50, 50, 50, 25, 25, 25, 2, 2, 2, 25, 25, 25, 62, 62, 62, 35, 35, 35, 66, 66],
          },
        ],
        chart: {
          height: 170,
        },
      },
    },
  ],
};

export const TotalExpendituresChart: ApexOptions = {
  series: [
    {
      name: "Earning",
      data: [92, 64, 43, 80, 58, 92, 46, 76, 80, 30, 50],
    },
  ],
  chart: {
    type: "bar",
    toolbar: {
      show: false,
    },
    height: 180,
    stacked: true,
  },
  states: {
    hover: {
      filter: {
        type: "darken",
      },
    },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      borderRadius: 3,
      columnWidth: "35%",
    },
  },
  dataLabels: {
    enabled: false,
  },
  grid: {
    yaxis: {
      lines: {
        show: false,
      },
    },
  },
  xaxis: {
    labels: {
      show: false,
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    show: false,
  },
  fill: {
    opacity: 1,
    colors: ["#dd7031", "#F2F5FA"],
  },
  legend: {
    show: false,
  },
  tooltip: {
    custom: function ({ series, seriesIndex, dataPointIndex }) {
      return '<div class="apex-tooltip p-2">' + "<span>" + '<span class="bg-primary">' + "</span>" + "Expenses" + "<h3>" + "$" + series[seriesIndex][dataPointIndex] + "<h3/>" + "</span>" + "</div>";
    },
  },
};

export const OrderThisMonthChart: ApexOptions = {
  series: [
    {
      name: "series1",
      data: [42.5, 40, 36, 32, 28, 25, 22, 20, 18, 16.5, 15.5, 15, 15, 16, 18, 20, 23, 26, 30, 34, 38, 41.5, 45, 48, 51, 54, 56, 58, 59, 59, 58, 56.5, 54.5, 51.5, 48, 44],
    },
    {
      name: "series2",
      data: [57, 58, 58, 57.5, 56.5, 55, 52.5, 50, 47, 43.5, 40, 36, 32, 28, 24, 20, 17, 15, 14.0, 14, 15, 17, 20, 24, 28, 32, 36, 40, 44, 48, 51.5, 54.5, 56.6, 58, 58.5, 58],
    },
  ],
  chart: {
    height: 305,
    width: "100%",
    type: "line",
    offsetY: 12,
    toolbar: {
      show: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  colors: [primary, secondary],
  markers: {
    size: 5,
    strokeColors: "#fff",
    strokeWidth: 2,
    discrete: [],
    shape: "circle",
    offsetX: 0,
    offsetY: 0,
    onClick: undefined,
    onDblClick: undefined,
    showNullDataPoints: true,
    hover: {
      size: 10,
    },
  },
  stroke: {
    curve: "straight",
    lineCap: "butt",
    width: 3,
  },
  grid: {
    show: true,
    borderColor: "var(--border-light)",
    strokeDashArray: 0,
    position: "back",
    padding: {
      top: -20,
      right: 10,
      bottom: 0,
      left: 12,
    },
  },
  yaxis: {
    logBase: 100,
    tickAmount: 6,
    min: 0,
    max: 60,
    labels: {
      show: true,
      align: "right",
      minWidth: 0,
      maxWidth: 25,
      formatter: (value) => {
        return `${value}k`;
      },
    },
  },
  xaxis: {
    type: "category",
    categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    tickAmount: 12,
    labels: {
      minHeight: undefined,
      maxHeight: 28,
      offsetX: 10,
      offsetY: 0,
    },
  },
  tooltip: {
    custom: function ({ series, seriesIndex, dataPointIndex, w }) {
      return `<div class="apex-tooltip"> 
                <span>
                    <span class="bg-secondary"> </span>
                      Selling : ${series[0][dataPointIndex]} K
                </span> 
                <span class="mt-2">
                    <span class="bg-primary"> </span>
                      Selling : ${series[1][dataPointIndex]} K
                </span> 
              </div>`;
    },
  },
  legend: {
    show: false,
  },
  responsive: [
    {
      breakpoint: 1200,
      options: {
        series: [
          {
            name: "series1",
            data: [42.5, 40, 36, 32, 28, 25, 22, 20, 18, 16.5, 15.5, 15, 15, 16, 18, 20, 23, 26, 30, 34, 38],
          },
          {
            name: "series2",
            data: [57, 58, 58, 57.5, 56.5, 55, 52.5, 50, 47, 43.5, 40, 36, 32, 28, 24, 20, 17, 15, 14.0, 14, 15],
          },
        ],
        chart: {
          height: 160,
        },
      },
    },
  ],
};

export const TotalSalesChart: ApexOptions = {
  series: [
    {
      name: "series2",
      data: [0, 40, 25, 80, 35, 40, 38, 50, 35, 70, 40, 100, 20],
    },
  ],
  chart: {
    height: 105,
    type: "area",
    sparkline: {
      enabled: true,
    },
  },
  dataLabels: {
    enabled: false,
  },
  colors: [primary],
  fill: {
    type: ["gradient"],
    gradient: {
      shade: "light",
      type: "vertical",
      shadeIntensity: 1,
      gradientToColors: [primary],
      inverseColors: true,
      opacityFrom: 0.6,
      opacityTo: 0,
      stops: [0, 100, 100, 100],
    },
  },
  stroke: {
    curve: "smooth",
    width: 2,
  },
  tooltip: {
    custom: function ({ series, seriesIndex, dataPointIndex }) {
      return '<div class="apex-tooltip p-2">' + "<span>" + '<span class="bg-primary">' + "</span>" + "Total-Sales" + "<h3>" + "$" + series[seriesIndex][dataPointIndex] + "<h3/>" + "</span>" + "</div>";
    },
  },
};

export const TotalVisitorChart: ApexOptions = {
  series: [
    {
      name: "series2",
      data: [60, 50, 114, 65, 56, 93, 50, 72, 60, 50, 114, 65, 56],
    },
  ],
  colors: ["#e87f2433", "#e87f2433", "#e87f2433", "#e87f2433", "#dd7031", "#dd7031", "#dd7031", "#dd7031", "#dd7031", "#e87f2433", "#e87f2433", "#e87f2433", "#e87f2433"],
  chart: {
    height: 105,
    type: "bar",
    offsetY: 25,
    sparkline: {
      enabled: true,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: "smooth",
  },
  plotOptions: {
    bar: {
      borderRadius: 10,
      distributed: true,
      barHeight: "35%",
      dataLabels: {
        position: "top",
      },
    },
  },
  tooltip: {
    custom: function ({ series, seriesIndex, dataPointIndex }) {
      return '<div class="apex-tooltip p-2">' + "<span>" + '<span class="bg-primary">' + "</span>" + "Total-Visitors" + "<h3>" + "$" + series[seriesIndex][dataPointIndex] + "<h3/>" + "</span>" + "</div>";
    },
  },
};

export const VisitorsChart: ApexOptions = {
  series: [
    {
      name: "Active",
      data: [18, 50, 65, 18, 28, 70, 15, 35],
    },
    {
      name: "Bounce",
      data: [35, 70, 30, 60, 25, 45, 50, 50],
    },
  ],
  chart: {
    type: "bar",
    height: 220,
    toolbar: {
      show: false,
    },
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: "50%",
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    show: true,
    width: 6,
    colors: ["transparent"],
  },
  grid: {
    show: true,
    borderColor: "var(--chart-border)",
    xaxis: {
      lines: {
        show: true,
      },
    },
  },
  colors: ["var(--theme-secondary)", "var(--theme-default)"],
  xaxis: {
    categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun", "Mon"],
    tickAmount: 4,
    tickPlacement: "between",
    labels: {
      style: {
        fontFamily: "Rubik, sans-serif",
      },
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    min: 0,
    max: 100,
    tickAmount: 5,
    labels: {
      style: {
        fontFamily: "Rubik, sans-serif",
      },
    },
  },
  fill: {
    opacity: 1,
  },
  legend: {
    position: "top",
    horizontalAlign: "left",
    fontFamily: "Rubik, sans-serif",
    fontSize: "14px",
    fontWeight: 500,
    labels: {
      colors: "var(--chart-text-color)",
    },

    itemMargin: {
      horizontal: 10,
    },
  },
  responsive: [
    {
      breakpoint: 1366,
      options: {
        plotOptions: {
          bar: {
            columnWidth: "80%",
          },
        },
        grid: {
          padding: {
            right: 0,
          },
        },
      },
    },
    {
      breakpoint: 1200,
      options: {
        plotOptions: {
          bar: {
            columnWidth: "50%",
          },
        },
        grid: {
          padding: {
            right: 0,
          },
        },
      },
    },
    {
      breakpoint: 576,
      options: {
        plotOptions: {
          bar: {
            columnWidth: "60%",
          },
        },
        grid: {
          padding: {
            right: 5,
          },
        },
      },
    },
  ],
};
